import { ctxTargetAttributes } from '@/contexts/TargetAttributesContext';
import { TargetAttributesTabValue } from '@/types';
import { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import FloatingBottomButton from '@/components/common/FloatingBottomButton';

export default function TargetAttributesMobileFooter() {
  const targetAttrCtx = useContext(ctxTargetAttributes);
  const { t } = useTranslation();

  if (!targetAttrCtx || !targetAttrCtx.selectedTargets) return;

  const targetCount = targetAttrCtx.selectedTargets.length;
  const onEntitySelector = targetAttrCtx.tab === TargetAttributesTabValue.entitySelect;

  return (
    <>
      {targetCount > 0 && onEntitySelector && (
        <FloatingBottomButton
          title={t('targetAttributes.edit', { targetCount })}
          onAction={() => targetAttrCtx.setTab(TargetAttributesTabValue.result)}
          bottom={12}
          position="absolute"
        />
      )}
    </>
  );
}
